import Help from '../models/Help'

const state = {
  help_categories: []
}

const mutations = {
  'SET_HELP_CATEGORIES'(state, help_categories) {
    state.help_categories = help_categories;
  },
}

const actions = {
    async set_help_categories({commit}) {
        try {
            let help_categories = await Help.getIndex()
            commit('SET_HELP_CATEGORIES', help_categories.categories)
            return help_categories.data
        } catch (e) {
            return e
        }
    },
}

const getters = {
  help_categories: state => {
    return state.help_categories;
  },
}

export default {
  state,
  mutations,
  actions,
  getters
};
